<template>
  <page>
              <v-expansion-panels v-model="panel1" multiple>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
                    </v-expansion-panel-header>
                <v-expansion-panel-content>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-radio-group class="d-flex" v-model="form.printType" :mandatory="true" @change="doBchReprnt($event)">
                  <v-radio :label="label.bchPrint" value="bchPrint"></v-radio>
                  <v-row no-gutters>
                    <v-col cols="12" lg="12" md="12" sm="12">
                      <v-checkbox color="primary" :label="label.separate" v-model="form.separate" clearable></v-checkbox>
                    </v-col>
                    <v-col class="pa-2" cols="12" lg="4" md="4" sm="12">
                      <v-autocomplete
                        :items="tranTypes"
                        v-model="form.tranType"
                        :label="label.tranType"
                        item-text="text"
                        item-value="value"
                        data-vv-name="form.tranType"
                        :data-vv-as="label.tranType"
                        :error-messages="errors.collect('form.tranType')"
                        :disabled="this.form.printType === 'reprint'"
                      ></v-autocomplete>
                    </v-col>
                    <v-col class="pa-2" cols="12" lg="4" md="4" sm="12">
                      <v-text-field
                        v-model="form.branch"
                        :label="label.branch"
                        :error-messages="errors.collect('branch')"
                        data-vv-name="branch"
                        :data-vv-as="label.branch"
                        append-icon="mdi-magnify"
                        @click:append="getHelpList('branch')"
                        :disabled="this.form.printType === 'reprint'"
                        v-validate="validateBchPrint"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-2" cols="12" lg="4" md="4" sm="12">
                      <v-text-field
                        v-model="form.documentNo"
                        :label="label.documentNo"
                        :error-messages="errors.collect('documentNo')"
                        data-vv-name="documentNo"
                        :data-vv-as="label.documentNo"
                        append-icon="mdi-magnify"
                        @click:append="getDocNoList('docNo1')"
                        :disabled="this.form.printType === 'reprint'"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-radio :label="label.reprint" value="reprint"></v-radio>
                  <v-row no-gutters>
                    <v-col class="pa-2" cols="12" lg="4" md="4" sm="12">
                      <v-autocomplete
                        :items="tranTypes"
                        v-model="form.tranType2"
                        :label="label.tranType2"
                        item-text="text"
                        item-value="value"
                        data-vv-name="form.tranType2"
                        :data-vv-as="label.tranType2"
                        :error-messages="errors.collect('form.tranType2')"
                        :disabled="this.form.printType === 'bchPrint'"
                      ></v-autocomplete>
                    </v-col>
                    <v-col class="pa-2" cols="12" lg="4" md="4" sm="12">
                      <v-autocomplete
                        :items="branchesList"
                        v-model="form.branch2"
                        :label="label.branch2"
                        item-text="label"
                        item-value="value"
                        data-vv-name="branch2"
                        @change="clearDocNo"
                        :disabled="this.form.printType === 'bchPrint'"
                        v-validate="validateReprint"
                        :data-vv-as="label.branch2"
                        :error-messages="errors.collect('branch2')"
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <v-col class="pa-2" cols="12" lg="4" md="4" sm="12">
                      <v-text-field
                        v-model="form.documentNo2"
                        :label="label.documentNo2"
                        :error-messages="errors.collect('documentNo2')"
                        data-vv-name="documentNo2"
                        :data-vv-as="label.documentNo2"
                        append-icon="mdi-magnify"
                        @click:append="getDocNoList('docNo2')"
                        @blur="checkAcctMasterByDocPrtd()"
                        :disabled="this.form.printType === 'bchPrint'"
                        v-validate="docNoReprintValidation"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
          <v-dialog v-model="showErrorDialog" width="800px">
            <acct-info-dialog :messageData="messages" @close="showErrorDialog = false"></acct-info-dialog>
          </v-dialog>

          <v-dialog v-model="helplist" width="900px" persistent>
            <helplist :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)"></helplist>
          </v-dialog>

          <!--Added: 30/May/2020  Show DocNo Help List -->
          <v-dialog v-model="showDocHelpList1" width="1080px">
            <doc-no-help-list
              :callerPage="'AccountsDocument'"
              :boolRefresh="showDocHelpList1"
              @close="showDocHelpList1 = false"
              :branch="form.branch"
              :tranType="form.tranType"
              :docPrtd="form.docPrtd"
              :docPrtILN="form.docPrtILN"
              @assign-doc-no="assignDocNo1"
            ></doc-no-help-list>
          </v-dialog>

          <v-dialog v-model="showDocHelpList2" width="1080px">
            <doc-no-help-list
              :callerPage="'AccountsDocument'"
              :boolRefresh="showDocHelpList2"
              @close="showDocHelpList2 = false"
              :branch="form.branch2"
              :tranType="form.tranType2"
              :docPrtd="form.docPrtd"
              :docPrtILN="form.docPrtILN"
              @assign-doc-no="assignDocNo2"
            ></doc-no-help-list>
          </v-dialog>
    <v-spacer class="mt-3"></v-spacer>
            <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              Export To
            </v-btn>
            <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{ format.label }}</span>
                <v-icon :color="format.color">{{ format.icon }}</v-icon>
              </v-btn>
            </v-btn-toggle>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import Helplist from '@/components/reports/accounts/Helplist'
import clone from 'clone'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import DocNoHelpList from '@/components/core/common/dialog/DocNoHelpList'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import AcctInfoDialog from '@/components/core/accounting/dialog/AcctInfoDialog'
// import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      label: {
        bchPrint: 'Batch Print',
        reprint: 'Reprint',
        tranType: 'Transaction Type',
        branch: 'For Branch',
        documentNo: 'Document No',
        separate: 'Separate',
        tranType2: 'Transaction Type',
        branch2: 'Branch',
        documentNo2: 'Document No'
      },
      form: {
        printType: 'bchPrint',
        bchPrint: 'bchPrint',
        reprint: 'reprint',
        tranType: 'Y',
        branch: 'All',
        documentNo: '',
        docPrtd: '',
        docPrtILN: '',
        separate: false,
        format: '',
        tranType2: 'Y',
        branch2: '',
        documentNo2: ''
      },
      tranTypes: [
        { text: 'A - Debit Note', value: 'A' },
        { text: 'B - Credit Note', value: 'B' },
        { text: 'Y - Receipt', value: 'Y' },
        { text: 'Z - Payment', value: 'Z' }
      ],
      menu: {},
      helplist: false,
      apiURI: '',
      mode: '',
      param: '',
      showDocHelpList1: false,
      showDocHelpList2: false,
      submitting: false,
      supportedFormat: [],
      showErrorDialog: false,
      validateBchPrint: '',
      validateReprint: '',
      refreshDoc: true,
      tempForm: {
        printType: '',
        bchPrint: '',
        reprint: '',
        branch: '',
        documentNo: '',
        separate: '',
        tranType: '',
        docPrtd: '',
        docPrtILN: ''
      },
      branches: [],
      branchesList: [],
      checkDocNo: false,
      panel1: [0]
    }
  },
  methods: {
    async getBranchList() {
      const apiUrl = this.$store.state.commons.menu.branchList
      if (apiUrl) {
        const result = await this.$http.get(apiUrl)
        if (result.data.branchList) {
          this.$set(this, 'branches', result.data.branchList)
        }
      }
    },
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getBranches('branchesList')
      this.doBchReprnt('bchPrint')
      try {
        if (this.$store.state.reports.acctReports.init !== 1) {
          await this.$store.dispatch('acctReportsInit')
        }
        const apiURI = this.rptMenu.acctDocBchReprnt
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doBchReprnt(data) {
      this.resetValidator()
      this.form.printType = data
      if (data === 'bchPrint') {
        this.form.tranType2 = 'Y'
        this.form.branch2 = ''
        this.form.branch = 'All'
        this.form.documentNo2 = ''
        this.form.documentNo = ''
        this.form.bchPrint = data
        this.form.reprint = ''
        this.form.docPrtd = false
        this.form.docPrtILN = 'L'
        this.validateBchPrint = 'required'
        this.validateReprint = ''
      } else {
        this.form.tranType = 'Y'
        this.form.branch = ''
        this.form.branch2 = ''
        this.form.documentNo = ''
        this.form.documentNo2 = ''
        this.form.reprint = data
        this.form.bchPrint = ''
        this.form.docPrtd = true
        this.form.docPrtILN = ''
        this.form.separate = false
        this.validateBchPrint = ''
        this.validateReprint = 'required'
      }
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      if (fieldName === 'branch') {
        this.apiURI = this.rptMenu.getBranchList
        if (this.form.printType === 'bchPrint') {
          this.param = this.form.branch
          this.form.documentNo = ''
        } else {
          this.param = this.form.branch2
          this.form.documentNo2 = ''
        }
        this.helplist = true
      }
    },
    clearDocNo() {
      this.form.documentNo2 = ''
    },
    getDocNoList(fieldName) {
      this.mode = fieldName
      this.tempForm.docPrtd = this.form.docPrtd
      this.tempForm.docPrtILN = this.form.docPrtILN
      if (this.form.printType === 'bchPrint') {
        this.tempForm.branch = this.form.branch
        this.tempForm.tranType = this.form.tranType
      } else {
        this.tempForm.branch = this.form.branch2
        this.tempForm.tranType = this.form.tranType2
      }
      if (fieldName === 'docNo1') {
        this.$validator.validate('branch').then((result) => {
          if (result) {
            this.showDocHelpList1 = true
          }
        })
      }
      if (fieldName === 'docNo2') {
        this.$validator.validate('branch2').then((result) => {
          if (result) {
            this.showDocHelpList2 = true
          }
        })
      }
    },
    assignDocNo1(docNo) {
      this.form.documentNo = docNo
      this.showDocHelpList1 = false
    },
    assignDocNo2(docNo) {
      this.form.documentNo2 = docNo
      this.showDocHelpList2 = false
    },
    doAssign(Obj) {
      if (this.form.printType === 'bchPrint') {
        switch (this.mode) {
          case 'branch':
            this.form.branch = ''
            this.form.branch = Obj.finalSelectedItems.toString()
            break
          // case 'documentNo': this.form.documentNo = ''
          //   this.form.documentNo = Obj.selectedItems.toString()
          //   break
        }
      } else {
        switch (this.mode) {
          case 'branch':
            this.form.branch2 = ''
            this.form.branch2 = Obj.finalSelectedItems.toString()
            break
          // case 'documentNo': this.form.documentNo2 = ''
          //   this.form.documentNo2 = Obj.selectedItems.toString()
          //   break
        }
      }
    },
    doClose() {
      this.helplist = false
      this.showDocHelpList = false
    },
    doExport() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.form.printType !== '' && this.form.printType === 'bchPrint') {
            if (this.form.documentNo !== '' && (this.form.branch.split(',').length > 1 || (this.form.branch === 'All' && this.branches.length > 1))) {
              this.displayMsg('bchPrint')
            } else {
              const param = {
                printType: this.form.printType,
                bchPrint: this.form.bchPrint,
                reprint: this.form.reprint,
                branch: this.form.branch,
                documentNo: this.form.documentNo,
                separate: this.form.separate,
                tranType: this.form.tranType,
                docPrtd: this.form.docPrtd,
                docPrtILN: this.form.docPrtILN
              }
              this.processExport(param)
            }
          } else {
            if (this.form.branch2.split(',').length > 1 || (this.form.branch2 === 'All' && this.branches.length > 1)) {
              this.displayMsg('reprint')
            } else {
              const param = {
                printType: this.form.printType,
                bchPrint: this.form.bchPrint,
                reprint: this.form.reprint,
                branch: this.form.branch2,
                documentNo: this.form.documentNo2,
                separate: this.form.separate,
                tranType: this.form.tranType2,
                docPrtd: this.form.docPrtd,
                docPrtILN: this.form.docPrtILN
              }
              this.processExport(param)
            }
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport(param) {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let messageFilters
          messageFilters = clone(param)
          await this.$http.post(apiURI, messageFilters)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    displayMsg(param) {
      var errMsg
      var messages = []
      if (param === 'bchPrint') {
        messages.push({ message: 'Document No. is not blank - then "For Branch" must only equal to 1 branch code', type: 'ERROR' })
      } else {
        messages.push({ message: 'Only 1 branch code can be selected', type: 'ERROR' })
      }

      if (messages.length > 0) {
        errMsg = { messages }
        this.message(errMsg)
        this.fieldMessage(errMsg)
      }
    },
    async checkAcctMasterByDocPrtd() {
      const apiURI = this.menu.checkAcctMasterByDocPrtd
      const param = {
        printType: this.form.printType,
        bchPrint: this.form.bchPrint,
        reprint: this.form.reprint,
        branch: this.form.branch2,
        documentNo: this.form.documentNo2,
        separate: this.form.separate,
        tranType: this.form.tranType2,
        docPrtd: this.form.docPrtd,
        docPrtILN: this.form.docPrtILN
      }
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, param)
          const { data } = result.data
          if (data) {
            this.checkDocNo = false
          } else {
            this.checkDocNo = true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('docNoValidation', {
      getMessage(field, args) {
        var acctMasterFound = args[0]
        if (acctMasterFound === 'true') {
          return `No record found in Account Master.`
        } else {
          return `No record found`
        }
      },
      validate(value, args) {
        if (value) {
          var acctMasterFound = args[0]
          // var ttyDetExpDate = args[1]
          if (acctMasterFound === 'true') {
            return false
          } else {
            return true
          }
        }
      }
    })
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.acctReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    displayErrorDialog() {
      return this.messages
    },
    docNoReprintValidation() {
      if (this.checkDocNo === true) {
        return 'required|docNoValidation:' + this.checkDocNo
      } else {
        return 'required'
      }
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    supportedList: function (value) {
      if (value && value.length > 0) {
        this.form.format = value[0].value
      }
    },
    'form.tranType': function () {
      if (this.form.printType === 'bchPrint') {
        this.doBchReprnt(this.form.printType)
      }
    },
    'form.tranType2': function () {
      if (this.form.printType === 'reprint') {
        this.doBchReprnt(this.form.printType)
      }
    }
  },
  mixins: [MessageMixin, reportFormat, commonAjaxMixin],
  components: {
    Helplist,
    DocNoHelpList,
    AcctInfoDialog
  }
}
</script>
